class LinkedProductsSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[data-slider]');
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    new Splide(this.slider, {
      arrows: true,
      pagination: false,
      perPage: 6,
      mediaQuery: 'min',
      breakpoints: {
        1000: {
          perPage: 7,
        },
      },
      perMove: 1,
      omitEnd: true,
    }).mount();
  }

}

if (!customElements.get('linked-products-slider')) {
  customElements.define('linked-products-slider', LinkedProductsSlider);
}